import React from "react";

const BUILD_URL = process.env.PUBLIC_URL;
export default function Image({ src, ...props }) {
  return <img src={`${BUILD_URL}${src}`} {...props} alt={props.alt || ""} />;
}
